import React, { useEffect, useState } from "react";
import { useLocation,useParams } from "react-router-dom";
import Header from "./Header";
import MultiViewDICOM from "./MultiViewDICOM";
import DICOMViewer from "./DICOMViewer";
import AnnotationTile from "../dicomViewer/AnnotationTile";
import { ViewerProvider, useViewer } from "./context/ViewerContext";
import RadiologistApi from "../../../services/ApiServices/RadiologistApi";
import DicomSlices from "../dicomViewer/DicomSlices";
import MeasurementFilter from "../../app/dicomViewer/MeasurementFilter";
import Report from "../../../components/popups/Report";
import { ButtonCustom } from "../../../components/input/ButtonCustom";
import Sparks from "../../../assets/Sparks.svg";
import NewAnnotation from "../dicomViewer/NewAnnotation";
import { loadMultiExams } from "./utils/multiView_l";
import Graph from "../../../components/popups/Graph";
import SystemMessage from "../../../components/customComp/SystemMessage";
import axios from "axios";
import JSZip from "jszip";
import spinner from "../../../assets/spiner.svg";

const ViewerLayout = ({addTab}) => {
  return (
    <ViewerProvider>
      <ViewerLayoutInner addTab={addTab}/>
    </ViewerProvider>
  );
};

const ViewerLayoutInner = ({addTab}) => {
  const location = useLocation();
  const state = location.state;

  const { patientID, caseID } = useParams();
  const [loading, setLoading] = useState(false);
  
    // ---- Helpers + refs for per-case view state ----
    const makeCaseKey = (patientId, caseId) =>
      patientId && caseId ? `${patientId}-${caseId}` : null;
  
    // which case we already restored in this mount
    const restoredCaseRef = React.useRef(null);
  
    // guard so "first nodule" logic runs only once per case
    const hasInitialSliceRef = React.useRef(false);
  
  // prevent repeated init from `state`
  const initializedFromStateRef = React.useRef(null);

  const [examData, setExamData] = useState(null);
  const [rawData, setRawData] = useState(null);
  const [data, setData] = useState(null);
  const [grainMap, setGrainMap] = useState(new Map());
  const [currentUser, setCurrentUser] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentGrainId, setCurrentGrainId] = useState(null);
  const [imageIds, setImageIds] = useState([]);
  const [selectedAnnotationId, setSelectedAnnotationId] = useState(null);
  const [showMeasurementFilter, setShowMeasurementFilter] = useState(false);
  const [noduleMinSize, setNoduleMinSize] = useState({ size: 6, unit: "mm" });
  const [showReportPopup, setShowReportPopup] = useState(false);
  const [reportStage, setReportStage] = useState("loading");
  const [accessionNumber, setAccessionNumber] = useState(null);
  const [isCreatingPersonalNote, setIsCreatingPersonalNote] = useState(false);
  const [showAllNotes, setShowAllNotes] = useState(false);
  const [multiExams, setMultiExams] = useState([]);
  const [isLoadingMulti, setIsLoadingMulti] = useState(false);
  const [totalExamCount, setTotalExamCount] = useState(1);

  const [systemError, setSystemError] = useState(null);
  const [systemErrorCount, setSystemErrorCount] = useState(0);

    // Reset initial-slice guard whenever case changes
    useEffect(() => {
      hasInitialSliceRef.current = false;
    }, [examData?.patientId, examData?.caseId]);

  const clearSystemError = () => {
    handleSystemError(null);
  };

  const handleSystemError = (message) => {
    setSystemErrorCount((prev) => prev + 1);
    setSystemError(message);
  };

  const {
    annotationsData,
    setAnnotationsData,
    deleteAnnotationFromData,
    activeTool,
    setActiveTool,
    notesOpen,
    splitState,
    setSplitState,
    graphOpen,
    setNotesOpen,
    setGraphOpen,
  } = useViewer();

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("loggedInUser");
    if (loggedInUser) {
      try {
        setCurrentUser(JSON.parse(loggedInUser));
      } catch (error) {
        console.error("Error parsing user:", error);
      }
    }
  }, []);

  const initFromDicomProps = React.useCallback((dicomProps) => {
    debugger
    setLoading(true)
    const parsed = {
      patientId: dicomProps.patientId,
      accessionNumber: dicomProps.accessionNumber,
      dicomFiles: dicomProps.dicomFiles,
      jsonData: dicomProps.jsonData,
      createdAt: dicomProps.createdAt,
      caseId: dicomProps.accessionNumber || "N/A",
    };
  
    setExamData(parsed);
    setRawData(dicomProps.jsonData);
    setData(dicomProps.jsonData);
  
    const map = new Map();
    dicomProps.jsonData?.grains?.forEach((g) => {
      map.set(Number(g.id), {
        mm: g.size?.mm ?? null,
        mm3: g.size?.mm3 ?? null,
      });
    });
    setGrainMap(map);
  
    const ids = dicomProps.dicomFiles.map((f) => `wadouri:${f}`);
    setImageIds(ids);
    setLoading(false)

  }, []);
  
  useEffect(() => {
    // no state → nothing to init
    if (!state) return;
  
    // make sure URL matches the state
    const isSameCaseAsState =
      state.accessionNumber === caseID &&
      state.patientId === patientID &&
      state.dicomFiles &&
      state.jsonData;
  
    if (!isSameCaseAsState) {
      return;
    }
  
    // build a unique key for the current case
    const currentCaseKey = `${state.patientId}-${state.accessionNumber}`;
  
    // already initialized for this case → don't do it again
    if (initializedFromStateRef.current === currentCaseKey) {
      return;
    }
  
    const dicomProps = {
      patientId: state.patientId,
      accessionNumber: state.accessionNumber,
      createdAt: state.createdAt,
      dicomFiles: state.dicomFiles,
      jsonData: state.jsonData,
    };
  
    initFromDicomProps(dicomProps);
  
    // only notify the tabs once per case
    addTab?.("case", state.patientId, state.accessionNumber, dicomProps);
  
    // remember which case we initialized
    initializedFromStateRef.current = currentCaseKey;
  }, [state, caseID, patientID, initFromDicomProps]);
  
  

  const goBackToMenu = () => {
    addTab("patient",state.patientId)
  }
  
  

  useEffect(() => {
    debugger
    if (examData) return;
    if (!caseID) return;
    if (state?.dicomFiles || state?.jsonData) return;
  
    let cancelled = false;
  
    const load = async () => {
      try {
        setLoading(true);
  
        const { dicomUrl, resultUrl } = await RadiologistApi.getResults(caseID);
        if (!dicomUrl || !resultUrl) {
          throw new Error("Missing DICOM or result URL");
        }
  
        const s3Axios = axios.create();
        const zipBuf = await s3Axios.get(dicomUrl, {
          responseType: "arraybuffer",
        });
  
        const zip = await JSZip.loadAsync(zipBuf.data);
        const files = await Promise.all(
          Object.values(zip.files)
            .filter((f) => !f.dir)
            .map(async (f) => new File([await f.async("blob")], f.name))
        );
  
        if (files.length === 0) {
          throw new Error("No DICOM files found in ZIP");
        }
  
        const resultResp = await s3Axios.get(resultUrl);
        if (cancelled) return;
  
        const dicomProps = {
          patientId: patientID,
          accessionNumber: caseID,
          createdAt: undefined,
          dicomFiles: files,
          jsonData: resultResp.data,
        };
  
        initFromDicomProps(dicomProps);
  
        // re-attach dicomProps to existing tab (in memory only)
        if (addTab) {
          addTab("case", patientID, caseID, dicomProps);
        }
      } catch (e) {
        console.error("Failed to load DICOM in ViewerLayout:", e);
        if (!cancelled) setSystemError("Failed to load DICOM data");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
  
    load();
    return () => {
      cancelled = true;
    };
  }, [caseID, patientID, examData, state, initFromDicomProps, addTab]);
  
  

  useEffect(() => {
    if (examData?.patientId && examData?.caseId) {
      RadiologistApi.markCaseOpened(examData.patientId, examData.caseId).catch(
        (err) => console.error("Failed to mark case opened:", err)
      );
    }
  }, [examData?.patientId, examData?.caseId]);

  useEffect(() => {
    if (activeTool === "MeasurementIcon") {
      setShowMeasurementFilter(true);
    }
  }, [activeTool]);

  useEffect(() => {
    if (!examData?.caseId) return;

    RadiologistApi.getAnnotations(examData.caseId)
      .then((res) => {
        const bySlice = {};

        // Process database annotations first
        (res?.annotations || []).forEach((a) => {
          // Slice index (keep whatever the API gives; adjust here if API is 1‑based)
          const slice = a.sliceIndex ?? a.slice ?? a.sliceNum;
          if (slice == null) return;

          // --- Parse measurementData (can be a JSON string with nested JSON strings) ---
          let md = a.measurementData || a.measurement_data || a.data;
          if (typeof md === "string") {
            try {
              md = JSON.parse(md);
            } catch {
              md = {};
            }
          }
          if (!md || typeof md !== "object") md = {};

          // Inside measurementData the keys might be: x, y, start, end, length
          // start / end themselves may be stringified JSON.
          let { x, y, start, end, length } = md;

          if (typeof start === "string") {
            try {
              start = JSON.parse(start);
            } catch {}
          }
          if (typeof end === "string") {
            try {
              end = JSON.parse(end);
            } catch {}
          }

          // Fallback to top-level fields if not in measurementData
          if (start == null && a.start) {
            start =
              typeof a.start === "string"
                ? (() => {
                    try {
                      return JSON.parse(a.start);
                    } catch {
                      return a.start;
                    }
                  })()
                : a.start;
          }
          if (end == null && a.end) {
            end =
              typeof a.end === "string"
                ? (() => {
                    try {
                      return JSON.parse(a.end);
                    } catch {
                      return a.end;
                    }
                  })()
                : a.end;
          }
          if (length == null) length = a.length;

          // Normalize start / end to {x, y}
          const normPoint = (p) => {
            if (!p) return undefined;
            if (Array.isArray(p) && p.length >= 2) {
              return typeof p[0] === "number" && typeof p[1] === "number"
                ? { x: p[0], y: p[1] }
                : undefined;
            }
            if (
              typeof p === "object" &&
              typeof p.x === "number" &&
              typeof p.y === "number"
            ) {
              return { x: p.x, y: p.y };
            }
            return undefined;
          };

          const startPt = normPoint(start);
          const endPt = normPoint(end);

          // Compute midpoint
          let midpoint;
          if (startPt && endPt) {
            midpoint = {
              x: (startPt.x + endPt.x) / 2,
              y: (startPt.y + endPt.y) / 2,
            };
          } else if (typeof x === "number" && typeof y === "number") {
            // fallback if only single point given
            midpoint = { x, y };
          }
          const ann = {
            id: a.id,
            slice,
            creator: a.creator,
            updatedAt: a.updatedAt,
            note: a.note || "",
            start: startPt,
            end: endPt,
            midpoint,
            length: typeof length === "number" ? length : undefined,
            type: a.type,
          };

          if (!bySlice[slice]) bySlice[slice] = [];
          bySlice[slice].push(ann);
        });

        // Add Genesis findings to the bySlice data
        data?.nodules?.forEach((n) => {
          const grain = data.grains?.find((g) => g.id === n.grain_id);
          if (!grain) return;

          const sliceIndex = grain.main_slice - 1;

          // Calculate world coordinates the same way as in markers
          const worldX = n.worldX ?? n.cx;
          const worldY = n.worldY ?? n.cy;

          const genesisAnnotation = {
            ...n,
            grain,
            id: `${String(n.id)}_finding`,
            originalId: n.id,
            slice: sliceIndex,
            creator: "Genesis AI",
            updatedAt: new Date().toISOString(),
            note: `Nodule detected on slice ${grain.main_slice}`,
            type: "finding", // This will now override any type from the nodule
            // Use calculated world coordinates
            x: worldX,
            y: worldY,
            // Add midpoint for consistency with other annotations
            midpoint: {
              x: worldX,
              y: worldY,
            },
            // Add location info
            location: n.location || "Unknown location",
            lung_rads_score: n.lung_rads_score,
          };

          if (!bySlice[sliceIndex]) bySlice[sliceIndex] = [];
          bySlice[sliceIndex].push(genesisAnnotation);
        });

        setAnnotationsData(bySlice);
      })
      .catch((err) => console.error("Failed to fetch annotations:", err));
  }, [examData?.caseId, setAnnotationsData, data?.nodules, data?.grains]);

  useEffect(() => {
    if (!data?.nodules?.length || !imageIds.length) return;

    // If we already set an initial slice for this case, don't override it
    if (hasInitialSliceRef.current) return;

    const firstNodule = data.nodules[0];
    const grain = data.grains?.find((g) => g.id === firstNodule.grain_id);
    if (grain?.main_slice != null) {
      const sliceIndex = Math.max(0, grain.main_slice - 1);
      setCurrentImageIndex(sliceIndex);
      setCurrentGrainId(grain.id);
      hasInitialSliceRef.current = true; // mark that we used our "init" once
    }
  }, [data, imageIds, setCurrentImageIndex]);


  const filterNodulesByMinSize = (minSizeObj) => {
    const value = Number(minSizeObj?.size);
    const unit = minSizeObj?.unit;
    if (!unit || isNaN(value) || !rawData) return;

    const filtered = rawData?.nodules?.filter((n) => {
      const grainId = Number(n.grain_id);
      const sizeData = grainMap.get(grainId);
      return sizeData?.[unit] != null && sizeData[unit] >= value;
    });

    setData({ ...rawData, nodules: filtered });
  };

  useEffect(() => {
    if (noduleMinSize) filterNodulesByMinSize(noduleMinSize);
    else if (rawData) setData(rawData);
  }, [noduleMinSize, rawData]);

  // click handler invoked by Header → preflight check (no state flip yet)
  const handleSplitClick = React.useCallback(async () => {
    if (!examData || !state?.patientId || splitState !== "off") return;

    try {
      // 1) preflight: do we have priors?
      const payload = await RadiologistApi.getAllCasesByPatient(
        state.patientId
      );
      const list = (payload?.exams || payload || []).filter(Boolean);

      const curId = String(examData.caseId ?? examData.accessionNumber ?? "");
      const priors = list.filter((c) => {
        const id = String(c.examId ?? c.caseId ?? c.accessionNumber ?? "");
        const status = String(c.status ?? "").toLowerCase();
        return (
          id !== curId && (status === "complete" || status === "completed")
        );
      });

      // 2) if none → show message, do NOT change splitState → no flicker
      if (priors.length === 0) {
        setSystemErrorCount((prev) => prev + 1);
        setSystemError("No prior exams available for comparison");
        return;
      }
      setNotesOpen(false);

      // 3) placeholders immediately, then hydrate
      setMultiExams([
        examData,
        ...Array(Math.min(3, priors.length)).fill(null),
      ]);
      setSplitState("loading");

      const toLoad = Math.min(3, priors.length);
      const others = await loadMultiExams(state.patientId, curId, toLoad);

      setMultiExams([examData, ...others]);
      setSplitState("on");
    } catch (err) {
      setSystemErrorCount((prev) => prev + 1);
      setSystemError("Unable to load prior exams");
      setSplitState("off");
      setMultiExams([]);
    }
  }, [splitState, examData, state?.patientId, setSplitState]);

  // ---- Restore per-case viewer state (slice + split) from sessionStorage ----
  useEffect(() => {
    if (!examData?.patientId || !examData?.caseId) return;

    const caseKey = makeCaseKey(examData.patientId, examData.caseId);
    if (!caseKey) return;

    // Avoid restoring more than once per case in this mount
    if (restoredCaseRef.current === caseKey) return;
    restoredCaseRef.current = caseKey;

    try {
      const raw = sessionStorage.getItem(`viewerState:${caseKey}`);
      if (!raw) return;

      const saved = JSON.parse(raw);

      // 1) Restore last slice index
      if (typeof saved.currentImageIndex === "number") {
        setCurrentImageIndex(saved.currentImageIndex);
        // we've chosen the slice explicitly, don't let "first nodule" override
        hasInitialSliceRef.current = true;
      }

      // 2) Restore split mode
      if (saved.splitOn && splitState === "off") {
        // This will refetch priors, same as manual split click
        handleSplitClick();
      } else if (!saved.splitOn && splitState !== "off") {
        setSplitState("off");
      }
    } catch (e) {
      console.error("Failed to restore viewer state", e);
    }
  }, [
    examData?.patientId,
    examData?.caseId,
    splitState,
    handleSplitClick,
    setCurrentImageIndex,
    setSplitState,
  ]);

// ---- Persist per-case viewer state (slice + split) to sessionStorage ----
useEffect(() => {
  if (!examData?.patientId || !examData?.caseId) return;

  const caseKey = makeCaseKey(examData.patientId, examData.caseId);
  if (!caseKey) return;

  const payload = {
    currentImageIndex,
    splitOn: splitState === "on",
  };

  try {
    sessionStorage.setItem(
      `viewerState:${caseKey}`,
      JSON.stringify(payload)
    );
  } catch (e) {
    console.error("Failed to store viewer state", e);
  }
}, [examData?.patientId, examData?.caseId, currentImageIndex, splitState]);
  

  useEffect(() => {
    if (!examData) return;
    if (!patientID || !caseID) return;
  
    // If we have dicomProps in state, let the "initFromDicomProps" effect handle it.
    if (state?.dicomFiles || state?.jsonData) return;
  
    // At this point: we have examData, URL params, but NO state.
    // This is exactly the "after refresh, then click another tab" scenario.
    if (
      examData.patientId !== patientID ||
      examData.caseId !== caseID
    ) {
      // Clear only examData; the loader effect will now kick in for the new case.
      setExamData(null);
    }
  }, [examData, patientID, caseID, state, setExamData]);
  


  useEffect(() => {
    debugger
    if (!state) return;  // no initial data, skip
  
    const tabPatient = state.patientId;
    const tabCase = state.accessionNumber;
  
    // If this tab no longer matches the loaded exam → reset viewer
    if (
      examData &&
      (examData.patientId !== tabPatient ||
       examData.caseId !== tabCase)
    ) {
      setSplitState("off");
      setMultiExams([]);
    }
  }, [state]);

  if (!examData || !data) {
    // return (
    //   <div className="flex items-center justify-center h-screen text-xl text-gray-600">
    //     Loading viewer...
    //   </div>
    // );
    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center z-50">
          <img
            src={spinner}
            alt="Loading…"
            className="animate-spin h-16 w-16 filter invert"
          />
          <p className="mt-4 text-white text-lg font-medium">
            Loading viewer data…
          </p>
        </div>
    );
  }

  return (
    <div className="w-screen h-screen bg-[#2E2E2E] flex flex-col">
      {/*alert*/}
      {systemError && (
        <SystemMessage
          type="warning"
          title="Error"
          key={`${systemError}${systemErrorCount}`}
          message={systemError}
          handleClose={clearSystemError}
        />
      )}
      <Header
        dicomData={examData}
        patientId={examData.patientId}
        onSplitClick={handleSplitClick}
        goBackToMenu={goBackToMenu}
      />
      {/* Main Layout: Slices | CT Viewer | Notes */}
      <div className="flex flex-row flex-grow overflow-hidden">
        {/* Left Panel: DICOM Slices */}
        <div className="w-[15rem] flex-shrink-0 flex flex-col bg-[#111111] overflow-y-auto">
          <DicomSlices
            imageIds={imageIds}
            currentGrainId={currentGrainId}
            initialSliceIndex={currentImageIndex}
            currentImageIndex={currentImageIndex}
            handleSliceClick={setCurrentImageIndex}
            data={data}
            examData={examData}
            annotationsData={annotationsData}
          />
        </div>

        {/* Center: DICOM Viewer */}
        <div className="flex-grow overflow-hidden p-[10px] gap-[10px]">
          <div className="w-full h-full flex items-center justify-center">
            {splitState !== "off" ? (
              <MultiViewDICOM
                exams={multiExams.length ? multiExams : [examData, null, null]}
                currentUser={currentUser}
                topLeftIndex={currentImageIndex}
                setTopLeftIndex={setCurrentImageIndex}
              />
            ) : (
              <DICOMViewer
                key={`${examData?.patientId || ""}-${examData?.caseId || examData?.accessionNumber || ""}`}
                examData={examData}
                currentUser={currentUser}
                currentImageIndex={currentImageIndex}
                setCurrentImageIndex={setCurrentImageIndex}
                notesOpen={notesOpen}
              />
            )}
          </div>
        </div>

        {/* Right Panel: Notes */}
        {notesOpen && (
          <div className="w-[15rem] flex-shrink-0 flex flex-col bg-[black] h-full overflow-y-auto">
            {/* Notes Header */}
            <div className="notes-header h-[3.125rem] border-b border-[#2B2B2B] text-white flex items-center justify-between p-4 flex-shrink-0">
              <p>Notes</p>
              <div
                className="text-[1.5rem] cursor-pointer hover:bg-[#5A3EFF] rounded-full w-8 h-8 flex items-center justify-center transition-colors"
                onClick={() => setIsCreatingPersonalNote(true)}>
                +
              </div>
              <div
                className="cursor-pointer hover:bg-[#5A3EFF] border border-white text-white text-xs w-12 h-6 flex items-center justify-center transition-colors rounded-md"
                onClick={() => setShowAllNotes((prev) => !prev)}>
                {showAllNotes ? "Slice" : "All"}
              </div>
            </div>

            {/* Notes Body */}
            <div className="notes-body flex-1 overflow-y-auto scrollbar-hide">
              <div className="py-6 px-3 pb-[6.25rem]">
                {/* Personal Note Form */}
                {isCreatingPersonalNote && (
                  <NewAnnotation
                    annotation={null}
                    examData={examData}
                    currentUser={currentUser}
                    onClose={() => setIsCreatingPersonalNote(false)}
                    mode="personal"
                    currentSlice={currentImageIndex + 1}
                  />
                )}

                {/* Annotations List */}
                {(showAllNotes
                  ? Object.values(annotationsData || {}).flat()
                  : annotationsData?.[currentImageIndex] || []
                )
                  .slice()
                  .sort((a, b) => {
                    if (a.type === "finding" && b.type !== "finding") return -1;
                    if (b.type === "finding" && a.type !== "finding") return 1;
                    return 0;
                  })
                  .map((a) => (
                    <AnnotationTile
                      key={a.id}
                      annotation={a}
                      currentUser={currentUser}
                      onDeleted={deleteAnnotationFromData}
                      selectedAnnotationId={selectedAnnotationId}
                      type={a.type}
                      handleAnnotationSelection={setSelectedAnnotationId}
                      currentSlice={a.slice || currentImageIndex + 1}
                      goToSlice={setCurrentImageIndex}
                      currentImageIndex={currentImageIndex}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Measurement Filter */}
      {showMeasurementFilter && (
        <MeasurementFilter
          initialValue={noduleMinSize.size}
          initialUnit={noduleMinSize.unit}
          onSave={({ size, unit }) => {
            setNoduleMinSize({ size, unit });
            setShowMeasurementFilter(false);
            setActiveTool(null);
          }}
          onCancel={() => {
            setShowMeasurementFilter(false);
            setActiveTool("MouseIcon");
          }}
        />
      )}
      {/* Floating Report Button */}
      <ButtonCustom
        label="Generate Report"
        onClick={() => {
          setShowReportPopup(true);
          setReportStage("loading");
        }}
        width="187px"
        height="42px"
        backgroundColor="#5A3EFF"
        textColor="#fff"
        borderRadius="5px"
        fontSize="14px"
        fontWeight="600"
        containerClassName={`fixed bottom-4 right-4 z-50 transition-opacity duration-150 ${
          splitState !== "off" ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
        svgIcon={<img src={Sparks} alt="Spark" className="w-19 h-22" />}
      />

      {/* Report Popup */}
      {showReportPopup && (
        <Report
          accessionNumber={examData.caseId}
          currentUser={currentUser}
          stage={reportStage}
          setStage={setReportStage}
          closePopUp={() => setShowReportPopup(false)}
          nodules={data.nodules}
        />
      )}
      {graphOpen && (
        <Graph title="Finding" onClose={() => setGraphOpen(false)} />
      )}

    {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center z-3000">
          <img
            src={spinner}
            alt="Loading…"
            className="animate-spin h-16 w-16 filter invert"
          />
          <p className="mt-4 text-white text-lg font-medium">
            Loading viewer data…
          </p>
        </div>
      )}
    </div>
  );
}
export default ViewerLayout;
